<template>
  <span>
    <span @click.stop="open">
      <slot></slot>
    </span>
    <el-dialog append-to-body :title="title" top="15vh" :visible="dialogVisible" width="400px" @close="confirm">
      <div class="dialog-wrap" style="padding-top: 10px;">
        <el-radio-group v-model="selectedId">
          <el-radio
            :label="item.id"
            v-for="(item,index) in list"
            :key="index"
            style="display: flex;margin-bottom: 20px; align-items: center;"
          >
            <div class="my-flex my-flex-1">
              <el-avatar v-if="item.logoUrl" :size="30" shape="square" :src="item.logoUrl"></el-avatar>
              <i v-else class="el-icon-notebook-1" style="font-size: 30px ;color: #666;" />
              <div class="my-flex-1 my-m-l-10">
                <div class="my-line-1 my-m-b-5">{{ item.company }}</div>
                <div class="my-line-1 my-type-info my-font-xs">{{ item.name }}</div>
              </div>
            </div>
          </el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirm" size="mini">确定</el-button>
      </div>
    </el-dialog>
  </span>
</template> 
  <script>
export default {
  name: '',
  components: {},
  props: {
    bookId: {
      type: [String, Number],
      default: ''
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: '选择账本'
    }
  },
  data() {
    return {
      dialogVisible: false,
      selectedId: ''
    }
  },
  computed: {},
  created() {},

  methods: {
    close() {
      this.dialogVisible = false
      this.$emit('close', this.selectedId)
    },
    confirm() {
      this.dialogVisible = false
      this.$emit('confirm', this.selectedId)
    },
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.selectedId = this.bookId
      })
    }
  }
}
</script>
            
      <style lang="scss" >
</style>
            